import AdminConfig from './admin'
import ClientView from './client'

export default {
  name: 'publicform',
  type: 'module',
  label: 'formulaire public',
  components: {
    admin: AdminConfig,
    client: ClientView
  },
  settings: {
    icon: 'mdi-form-select'
  }
}
